import React, { useState } from "react";
import { ChildrenProps } from "../models/componentModel";
import { userData } from "../Utils/Constant/Constant";

import { CredentialListResponseModel, exitingGroupDetailResponseModel, memberListResponseModel, userGroupResponseModel, UserListResponseModel } from "../models/memberAxiosModels";
import { } from "../Utils/Constant/UserDetailsConstant";
import { intialGroupDetail, intialUserGroup } from "../Utils/Constant/MemberConstant";


const MemberContext = React.createContext<MemberContextPayload | undefined>(
    undefined
);

export interface MemberContextPayload {
    memberUserListDetails: UserListResponseModel;
    setMemberUserListDetails: React.Dispatch<React.SetStateAction<UserListResponseModel>>;

    storedExistingMemberDetails: any;
    setStoredExistingMemberDetails: React.Dispatch<React.SetStateAction<any>>;

    // ACRYLIC TEAM
    // acrylicTeamListDetails: GetMemberProfileResponseModel
    // setMemberProfileResponseModel: React.Dispatch<React.SetStateAction<GetMemberProfileResponseModel>>\
    acrylicTeamListDetails: memberListResponseModel[]
    setAcrylicTeamListDetails: React.Dispatch<React.SetStateAction<memberListResponseModel[]>>

    userCredentialListDetails: CredentialListResponseModel | null;
    setUserCredentialListDetails: React.Dispatch<React.SetStateAction<CredentialListResponseModel | null>>;

    memberPayloadDetails: any;
    setMemberPayloadDetails: any;

    userGroupListDetails: userGroupResponseModel,
    setUserGroupListDetails: React.Dispatch<React.SetStateAction<userGroupResponseModel>>;

    existingUserGroupDetails: exitingGroupDetailResponseModel,
    setExitingUserGroupDetails: React.Dispatch<React.SetStateAction<exitingGroupDetailResponseModel>>;

    storedGroupDetails: any,
    setStoredGroupDetails: React.Dispatch<React.SetStateAction<any>>;


}

const MemberProvider = ({ children }: ChildrenProps) => {

    const [memberUserListDetails, setMemberUserListDetails] = useState<UserListResponseModel>({
        users: [],
        totalUserCount: 0,
        activeUserCount: 0,
        inActiveUserCount: 0,
        filteredUserCount: 0,
    });
    const [storedExistingMemberDetails, setStoredExistingMemberDetails] = useState<any>(null)
    const [userCredentialListDetails, setUserCredentialListDetails] = useState<CredentialListResponseModel | null>(null)

    // ACRYLIC TEAM
    const [acrylicTeamListDetails, setAcrylicTeamListDetails] = useState<memberListResponseModel[]>([])
    const [memberPayloadDetails, setMemberPayloadDetails] = useState<any>(null)

    // USER GROUP
    const [userGroupListDetails, setUserGroupListDetails] = useState<userGroupResponseModel>(intialUserGroup)
    const [existingUserGroupDetails, setExitingUserGroupDetails] = useState<exitingGroupDetailResponseModel>(intialGroupDetail)
    const [storedGroupDetails, setStoredGroupDetails] = useState<any>({
        groupId: null,
        groupName: null,
        userCount: null
    })


    const payload = {
        memberUserListDetails,
        setMemberUserListDetails,

        storedExistingMemberDetails,
        setStoredExistingMemberDetails,

        userCredentialListDetails,
        setUserCredentialListDetails,

        // ACRYLIC TEAM
        acrylicTeamListDetails,
        setAcrylicTeamListDetails,
        memberPayloadDetails,
        setMemberPayloadDetails,
        // ACRYLIC TEAM

        // USER GROUP
        userGroupListDetails,
        setUserGroupListDetails,

        existingUserGroupDetails,
        setExitingUserGroupDetails,

        storedGroupDetails,
        setStoredGroupDetails
        // USER GROUP
    };

    return (
        <MemberContext.Provider value={payload}>{children}</MemberContext.Provider>
    );
};

export { MemberContext, MemberProvider };
